import React from 'react'
import { Link } from 'react-router-dom'
import { Table, Space, Button } from 'antd'
import { EditOutlined } from '@ant-design/icons'
import { ListComponent, BaseListComponentProps } from '../BaseComponent'
import { SearchRequest } from '../../services/api/interfaces/ApiRequest'
import { Pagination } from 'components/Pagination'

type QuestionTemplateListProps = BaseListComponentProps & {
  loading: boolean,
  questionTemplates: any,
  pagination: any,

  editing?: any,

  loadQuestionTemplates: (args: SearchRequest) => void
}

export default class QuestionTemplateList extends ListComponent<QuestionTemplateListProps> {

  static defaultProps = {
    loading: false,
    questionTemplates: [],

    loadQuestionTemplates: () => {}
  }

  tableColumns = [
    {
      title: 'UUID',
      dataIndex: 'uuid',
      key: 'uuid',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.uuid - b.uuid
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a: any, b: any) => a.name - b.name
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.description - b.description
    },
    {
      title: 'Questions',
      dataIndex: 'questions_count',
      key: 'questions_count',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.questions_count - b.questions_count
    },
    {
      title: 'Actions',
      key: 'action',
      render: (text: string, record: any) => (
        <Space size='middle'>
          <Link to={`question-template/${record.uuid}`} ref={(refs) => this.actionRefs.edit.push(refs)}>
            <Button type="dashed" shape="round" icon={<EditOutlined />} />
          </Link>
        </Space>
      )
    }
  ]

  protected load() {
    this.props.loadQuestionTemplates({
      search: {
        questions: {
          with: {
            _count: true
          }
        }
      },
      options: {
        sort: ['name'],
        limit: 9999
      }
    })
  }

  render() {
    const { loading, pagination, questionTemplates , loadQuestionTemplates} = this.props

    return (
      <>
        <Table
          loading={loading}
          rowKey='uuid'
          columns={this.tableColumns}
          pagination={false}
          dataSource={questionTemplates}
        />
         <Pagination
          loading={loading}
          current={pagination?.page}
          pageSize={pagination?.limit}
          length={questionTemplates?.length}
          onChange={(pagination) =>
            this.handleTableChange(
              pagination,
              undefined,
              loadQuestionTemplates
            )
          }
        />
      </>
    )
  }
}
